import { Injectable } from '@angular/core';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { ArchivedFoldersService } from '../http/archived-folders.service';
import { IFolderCommentViewerService } from '../http/folder-comment-viewer-service.interface';
import { FolderCommentsService } from '../http/folder-comments.service';

@Injectable({
    providedIn: 'root',
})
export class FolderCommentsServiceProvider {
    constructor(
        private folderCommentsService: FolderCommentsService,
        private archivedFolderCommentsService: ArchivedFoldersService
    ) {}

    getService(type: ViewType): IFolderCommentViewerService {
        if (type === ViewType.Box || type === ViewType.Workflow) {
            return this.folderCommentsService;
        } else if (type === ViewType.ArchivingBox || type === ViewType.ArchivingWorkflow) {
            return this.archivedFolderCommentsService;
        }
        throw new Error('Unknown service type');
    }
}
